import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { cookieConsent } from '@/lib/cookieConsent';

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
  }
}

export const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    setShowBanner(cookieConsent.showConsentBanner());
  }, []);

  const handleAccept = () => {
    cookieConsent.setConsent(true);
    setShowBanner(false);
  };

  const handleReject = () => {
    cookieConsent.setConsent(false);
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <Card className="mx-auto max-w-4xl bg-background/95 backdrop-blur-sm border-border">
        <div className="p-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex-1">
              <h3 className="font-semibold text-foreground mb-2">
                Cookie Preferences
              </h3>
              <p className="text-sm text-muted-foreground">
                We use cookies to improve your experience, analyze site usage, and assist with our marketing efforts. 
                This helps us provide better salary insights and job recommendations.
              </p>
            </div>
            
            <div className="flex gap-3 flex-shrink-0">
              <Button
                variant="outline"
                size="sm"
                onClick={handleReject}
                className="text-muted-foreground hover:text-foreground"
              >
                Decline
              </Button>
              <Button
                size="sm"
                onClick={handleAccept}
                className="bg-primary text-primary-foreground hover:bg-primary/90"
              >
                Accept All
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};